import { Button } from "antd"
import { useTranslation } from "react-i18next"

export const DeleteButton = ({ handleDelete }) => {
   const { t } = useTranslation();
   return (
      <Button type="link" onClick={handleDelete}>
         {t('common.editOptions.delete')}
      </Button>
   )
}